const INDEX = "https://audio500-gateway-4u7rf79y.ts.gateway.dev";
// const LOCAL = "http://127.0.0.1:8080";

export const EnumEndpoint ={
  PRICES: `${INDEX}/prices`,
  QUOTE_GEN: `${INDEX}/generateQuotation`,
  // QUOTE_GEN: `${LOCAL || INDEX}/generateQuotation`,
}